// Fonts used by the report templates. Loaded once per page, wherever a report is drawn
// (the send dialog preview, or the render page Puppeteer screenshots).
const FONTS_URL = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,500;0,600;0,700;0,800;1,700;1,800&family=Inter:wght@400;500;600;700;800&display=block'

export function ensureReportFonts(): HTMLLinkElement | null {
  if (typeof document === 'undefined') return null
  const existing = document.getElementById('xert-report-fonts') as HTMLLinkElement | null
  if (existing) return existing
  const link = document.createElement('link')
  link.id = 'xert-report-fonts'
  link.rel = 'stylesheet'
  link.href = FONTS_URL
  document.head.appendChild(link)
  return link
}

/**
 * Resolves once the report fonts have loaded. document.fonts.ready alone isn't enough: it
 * resolves while the stylesheet is still on its way, before any font has started loading, and
 * with display=block a font that hasn't arrived draws invisible text.
 */
export async function reportFontsLoaded() {
  const link = ensureReportFonts()
  if (!link) return
  if (!link.sheet) {
    await new Promise((resolve) => {
      link.addEventListener('load', resolve, { once: true })
      link.addEventListener('error', resolve, { once: true })
    })
  }
  await Promise.all([
    '500 16px "Barlow Condensed"', '600 16px "Barlow Condensed"', '700 16px "Barlow Condensed"', '800 16px "Barlow Condensed"',
    'italic 700 16px "Barlow Condensed"', 'italic 800 16px "Barlow Condensed"',
    '400 16px Inter', '500 16px Inter', '600 16px Inter', '700 16px Inter', '800 16px Inter',
  ].map((font) => document.fonts.load(font).catch(() => null)))
  await document.fonts.ready
}
